import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
} from "@mui/material";
import { FleetDashboardOverviewApi } from "../../../../API/Iot-Api/FleetDashboardOverview/FleetDashobardOverview";
import { AllFleetResponse } from "../../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";
import { CSVLink } from "react-csv";
import { blue } from "@mui/material/colors";

interface FleetDailySummaryTableProps {
  searchQrCode: string;
  category: string;
}

const FleetDailySummaryTable: React.FC<FleetDailySummaryTableProps> = ({
  searchQrCode,
  category,
}) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState<any>();
  const [allfleet, setAllfleet] = useState<AllFleetResponse | null>(null);
  const [allfleetDownload, setAllfleetDownload] =
    useState<AllFleetResponse | null>(null);

  const [downloadpage, setDownloadPage] = useState(1);
  const [downloadrowsPerPage, setDownloadRowsPerPage] = useState(50000);
  const [userRole, setUserRole] = useState<string | null>(null);
  useEffect(()=>{
    const role = localStorage.getItem("authority");
    setUserRole(role);
  },[])
 const formatTime = (dateTime: string | null | undefined) => {
  if (!dateTime || typeof dateTime !== "string") {
    return "N/A"; // You can return any default value or message here
  }

  const formattedDateTime = dateTime.replace("T", " "); // Replace "T" with a space
  const date = new Date(formattedDateTime);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};


  const pageRange = 5;
  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#A4A2A2",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };

  useEffect(() => {
    //const searcValue = `${searchValInput ? `?search=${searchValInput}` : ""}`;
    const fetchAllFleetReport = async () => {
      try {
        const data: AllFleetResponse =
          await FleetDashboardOverviewApi.api.getAllFleetList(
            searchQrCode,
            category,
            page
          );

        setAllfleet(data);
        setTotalCount(data.data.total_count);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      }
    };
    fetchAllFleetReport();
  }, [searchQrCode, category, page]);

  useEffect(() => {
    //const searcValue = `${searchValInput ? `?search=${searchValInput}` : ""}`;
    const fetchDriverBehaviorReportDownload = async () => {
      try {
        const data: AllFleetResponse =
          await FleetDashboardOverviewApi.api.getAllFleetListDownload(
            category,
            downloadpage,
            downloadrowsPerPage
          );

        setAllfleetDownload(data);
        setTotalCount(data.data.total_count);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      }
    };
    fetchDriverBehaviorReportDownload();
  }, [category, downloadpage, downloadrowsPerPage]);

  const allFleetReportButton = [
    { label: "User ID", key: "userid" },
    { label: "Mobile  No", key: "rider_mobile" },
    { label: "Vehicle No", key: "qrCode" },
    { label: "Fleet Model", key: "fleet_name" },
    { label: "End Time", key: "time" },
    { label: "Latitude", key: "lat" },
    { label: "Longitude", key: "lng" },
    { label: "hub_name", key: "risk_category" },
    { label: "IOT Type", key: "iot_type" },
    { label: "Device ID", key: "imei" },
    {
      label: "Day Since Last Iot Packet Received",
      key: "days_since_last_update",
    },
    { label: "Number Of Days On Ride", key: "days_since_ride_started" },
  ];
  return (
    <div className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl">
      <div className="w-full">
        <Grid container spacing={5} className="w-full flex justify-between ">
          <Grid item md={3}>
            <div className="flex ml-4">
              <h2 className="text-center ml-2 mx-1 mt-2 font-bold text-base text-black pb-2">
                Fleet Daily Summary Report{" "}
              </h2>
            </div>
          </Grid>
          <Grid item md={9}>
            <div className="flex mr-4">
              <div className="flex w-full justify-end">
              {(userRole === "ROLE_FLEET_SUPER_ADMIN" || 
    userRole === "ROLE_ADMIN" || 
    userRole === "ROLE_CO_ADMIN") && ( // Ensure this condition is checked
                <div>
                  <CSVLink
                    data={
                      searchQrCode
                        ? allfleet?.data.records_list || [] // Use filtered data if filters are applied
                        : allfleetDownload?.data.records_list || [] // Default to the full download dataset
                    }
                    headers={allFleetReportButton}
                    filename={`Fleet_Daily_Summary_Report.csv`}
                    style={{ marginRight: "10px" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#06B681",
                        padding: "8px 20px",
                        color: "#fff",
                        borderRadius: "25px",
                        width: "100%",
                        textTransform: "none",
                        marginLeft: "10px",
                      }}
                    >
                      Download
                    </Button>
                  </CSVLink>
                </div>
              )}
              </div>
            </div>
          </Grid>
        </Grid>
        <hr className="my-4" />
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 120 }}
                >
                  User ID
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 150 }}
                >
                  Mobile No
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 110 }}
                >
                  Vehicle No
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 150 }}
                >
                  Fleet Model
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 200 }}
                >
                  Last Updated Time
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 100 }}
                >
                  Last Location
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 200 }}
                >
                  Hub Name
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 150 }}
                >
                  IOT Type
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 130 }}
                >
                  Device ID
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 330 }}
                >
                  Day Since Last Iot Packet Received
                </TableCell>
                <TableCell
                  style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                  sx={{ minWidth: 230 }}
                >
                  Number Of Days On Ride
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allfleet?.data.records_list?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.userid}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.rider_mobile}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.qrCode}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.fleet_name}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {formatTime(item.time)}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    <a
                      style={{ color: blue[400] }}
                      href={`https://www.google.com/maps?q=${item.lat.toFixed(
                        6
                      )},${item.lng.toFixed(6)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.lat.toFixed(6)},{item.lng.toFixed(6)}
                    </a>
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.hub_name}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.iot_type}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.imei}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.days_since_last_update}
                  </TableCell>
                  <TableCell
                    style={{ ...tableBodyCellStyle, textAlign: "center" }}
                  >
                    {item.days_since_ride_started}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div className="pl-2 pt-4 pb-2 pr-16">
          <div
            className="pagination"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginRight: "6px",
                }}
              >
                {"<"}
              </button>
              {renderPageNumbers()}
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page >= pageCount - 1}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginLeft: "6px",
                }}
              >
                {">"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FleetDailySummaryTable;
